<div class="overflow-nav" #container [attr.aria-label]="ariaLabel()" role="navigation">
  <!-- Visible items. NOTE: deliberately NOT using `nz-menu nzMode="horizontal"`
       because NgZorro's built-in responsive overflow ghost would clone items
       and fight with our measurement/Priority+ logic. -->
  <ul class="overflow-nav__list">
    <li
      *ngFor="let item of visibleItems(); trackBy: trackByKey"
      routerLinkActive="overflow-nav__item--active"
      class="overflow-nav__item"
      [attr.data-nav-key]="item.key"
    >
      <a [routerLink]="item.route" (click)="onVisibleClick(item)">
        <nz-icon [nzType]="item.icon" />
        <span>{{ item.labelKey | translate }}</span>
        <span *ngIf="badgeCount(item) > 0" class="overflow-nav__count" aria-label="{{ badgeCount(item) }} offen">{{ badgeLabel(item) }}</span>
        <span *ngIf="hasDot(item)" class="overflow-nav__dot" aria-hidden="true"></span>
      </a>
    </li>

    <li
      *ngIf="hasOverflow()"
      class="overflow-nav__item overflow-nav__more"
      #moreBtn
      nz-dropdown
      [nzDropdownMenu]="moreMenu"
      nzTrigger="click"
      nzPlacement="bottomRight"
      [attr.aria-label]="'More navigation items'"
      aria-haspopup="menu"
      data-testid="overflow-nav-more"
    >
      <a>
        <nz-icon nzType="ellipsis" />
        <span>{{ 'app.nav.more' | translate}}</span>
      </a>
    </li>
  </ul>

  <nz-dropdown-menu #moreMenu="nzDropdownMenu">
    <ul nz-menu class="overflow-nav__dropdown">
      <li
        *ngFor="let item of overflowItems(); trackBy: trackByKey"
        nz-menu-item
        [routerLink]="item.route"
        routerLinkActive="ant-menu-item-selected"
        (click)="onOverflowClick(item)"
        [attr.data-nav-key]="item.key"
      >
        <nz-icon [nzType]="item.icon" />
        <span>{{ item.labelKey | translate }}</span>
        <span *ngIf="badgeCount(item) > 0" class="overflow-nav__count" aria-label="{{ badgeCount(item) }} offen">{{ badgeLabel(item) }}</span>
        <span *ngIf="hasDot(item)" class="overflow-nav__dot" aria-hidden="true"></span>
      </li>
    </ul>
  </nz-dropdown-menu>

  <!-- Hidden measurement row: contains ALL items so we can compute widths. -->
  <ul class="overflow-nav__measure" #measureList aria-hidden="true">
    <li
      *ngFor="let item of items(); trackBy: trackByKey"
      #measureItem
      class="overflow-nav__measure-item"
    >
      <nz-icon [nzType]="item.icon" />
      <span>{{ item.labelKey | translate }}</span>
      <span *ngIf="badgeCount(item) > 0" class="overflow-nav__count" aria-hidden="true">{{ badgeLabel(item) }}</span>
      <span *ngIf="hasDot(item)" class="overflow-nav__dot" aria-hidden="true"></span>
    </li>
  </ul>
</div>
